import React from 'react';

const AccountBalanceGraph: React.FC<{ total: number; used: number }> = ({ total, used }) => {
    return (
        <progress className="account-balance__progress-bar" max={total} value={used}>
            {Math.floor((used / total) * 100)} %
        </progress>
    );
};
export default AccountBalanceGraph;
